import { api } from '.';

interface TimeFilter {
  StartDate: string;
  EndDate: string;
  DaysOfWeek: number[];
  StartTimeOfDay: string | null;
  EndTimeOfDay: string | null;
}

interface Filters {
  HardwareIds: number[];
  ObservationTypes: { [key: string]: string[] };
  TimeFilter: TimeFilter;
}

interface ReportRequest {
  Name: string;
  Requestor: string;
  Recipients: string[];
  ReportTypes: number[];
  FileFormats: number[];
  UnitType: number;
  DataInterval: number;
  Filters: Filters;
}

const reportsApi = api.injectEndpoints({
  endpoints: builder => ({
    generateReport: builder.mutation<Blob, ReportRequest>({
      query: reportData => ({
        url: 'reports/generate',
        method: 'POST',
        body: reportData,
      }),
    }),
  }),
});

export const { useGenerateReportMutation } = reportsApi;
